
import React, { useRef } from 'react';

import './style.css'



import SignatureCanvas, { SignatureCanvasHandle } from './SignatureCanvas';

interface ISignatureModalProps {
    isOpen: boolean;
    onSave: () => void;
    onCancel: () => void;
    title?: string;
    newSignatureImageValue: (image: string) => void;
}

const SignatureModal: React.FC<ISignatureModalProps> = ({ isOpen, onSave, onCancel, title, newSignatureImageValue }) => {

    const canvasRef = useRef<SignatureCanvasHandle>(null);

    if (!isOpen) return null;

    const handleSave = async () => {
        const image = await canvasRef.current?.getImage();
        newSignatureImageValue(image ?? "");
        onSave();
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="center-middle">
                    <div className="font-size-17px">
                        <h1>{title || 'Sign Below'}</h1>
                    </div>
                </div>
                <SignatureCanvas ref={canvasRef} newImageValue={newSignatureImageValue} />
                <br />
                <div className="center-middle">
                    <button
                        type="button"
                        className="btn-save-signature center-middle"
                        onClick={handleSave}
                    >Save Signature</button>
                    &nbsp; &nbsp;
                    <button
                        type="button"
                        className="btn-white-green-2 center-middle"
                        onClick={onCancel}
                    >Cancel</button>
                </div>
            </div>
        </div>
    );
};

export default SignatureModal;